import React, { useEffect, useState } from 'react';
import { Card, Carousel, Col, Row } from 'antd';
import useApi from '../../hooks/useApi';
import { isEmpty } from '../../generalFunctions';

const HomePhotoGallery = () => {
    const [response, request] = useApi("/website/home/images?limit=4");
    const [photos, setPhotos] = useState([]);

    useEffect(() => {
        request();
    }, []);//eslint-disable-line

    useEffect(() => {
        if (!isEmpty(response.data) && !response.error && !response.isLoading) {
            setPhotos(response.data);
        }
    }, [response]);

    return (
        <Row gutter={[16, 16]}>
            {photos.map(photo => <Col xl={6} lg={6} md={12} sm={24} xs={24} key={photo.id}>
                <Carousel autoplay={{ dotDuration: true }} autoplaySpeed={5000} arrows>
                    {photo.images.map(image =>
                        <Card
                            key={image.id}
                            hoverable
                            cover={<img alt={photo.title} src={image.path} style={{ height: 200, objectFit: 'scale-down' }} />}
                        >
                            <p>{photo.title}</p>
                        </Card>

                    )}
                </Carousel>
            </Col>)}
        </Row>
    );
}

export default HomePhotoGallery;